<script>

import { mapActions, mapGetters } from "vuex";
import { required, minLength, maxLength, sameAs } from "vuelidate/lib/validators"; // for validators
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Layout from "../../layouts/main";
import {swal} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error';
import { VueContentLoading } from 'vue-content-loading';

export default {
  page: {
    title: "معلومات الامان",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading },
  data() {
    return {
      
      // title
      title: "معلومات الامان",
      items: [
        {
          text: "الرئيسية",
          href: "/",
        },
        {
          text: "معلومات الامان",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      // vuelidate
      admin: {
        username: '',
        password: '',
        newPassword: '',
        confirmNewPassword: '',
      },
      submitUsername: false,
      submitPassword: false,
      loadingButtonUsername: false,
      loadingButtonPassword: false,

      loadingContent: true,
    };
  },
  // vuelidate
  validations: {
    admin: {
      username: {required, minLength: minLength(3), maxLength: maxLength(30)},
      password: { required, minLength: minLength(8), maxLength: maxLength(50) },
      newPassword: { required, minLength: minLength(8), maxLength: maxLength(50) },
      confirmNewPassword: { required, sameAsPassword: sameAs("newPassword") },
    },
  },
  computed:{
    ...mapGetters('auth', ['getUser'])
  },
  methods: {
    ...mapActions('auth', ['changePassword', 'changeUsername']),
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    resetPasswordForm(){
      this.admin.password = ''
      this.admin.newPassword = ''
      this.admin.confirmNewPassword = ''
      this.loadingButtonPassword = false
    },
    resetUsernameForm(){
      this.loadingButtonUsername = false
    },
    formChangeUsername() { 
      this.submitUsername = true
      this.$v.$touch();
      if(this.$v.admin.username.$error) return

      // to form submit after this
      this.loadingButtonUsername = true
      this.errors = [];

      this.changeUsername({username: this.admin.username})
      .then((response)=>{
        swal.success(response.data)
        this.resetUsernameForm()
      })
      .catch((error)=>{
        this.handleError(error)
        this.resetUsernameForm();
      })
    },
    formChangePassword() { 
      this.submitPassword = true
      this.$v.$touch();
      let error = this.$v.admin.password.$error || this.$v.admin.newPassword.$error || this.$v.admin.confirmNewPassword.$error 
      if(error) return

      // to form submit after this
      this.loadingButtonPassword = true
      this.errors = [];

      this.changePassword({
        old_password: this.admin.password,
        new_password: this.admin.newPassword,
        new_password_confirmation: this.admin.confirmNewPassword,
      })
      .then((response)=>{
        swal.success(response.data)
        this.resetPasswordForm()
      })
      .catch((error)=>{
        this.handleError(error)
        this.loadingButtonPassword = false
      })
    }
  },
  created(){
    this.admin.username = this.getUser.username
  },
  mounted() {
      setTimeout(() => {
      this.loadingContent = false;
      }, 1000);
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <AlertError :errors="errors" />

            <b-form v-if="!loadingContent" class="mb-5 con-radius-input" @submit.prevent="formChangeUsername">
              <div class="title-separator"><h4>تغيير اسم المستخدم</h4></div>
              <div class="row">
                <b-form-group class="col-md-12 mb-3" label="اسم المستخدم :" label-for="username">
                    <b-form-input v-model="admin.username" :class="{ 'is-invalid': submitUsername && $v.admin.username.$error }" id="username" type="text" placeholder="ادخل اسم المستخدم"></b-form-input>
                    <div v-if="submitUsername && $v.admin.username.$error" class="invalid-feedback">
                      <span v-if="!$v.admin.username.required"> هذا الحقل الزامي </span>
                      <span v-if="!$v.admin.username.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 3 احرف على الاقل .</span>
                      <span v-if="!$v.admin.username.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 30 حرف على الاكثر . </span>
                    </div>
                </b-form-group> 
              </div>
              <div>
                <hr>
                  <b-button class="btn-block" type="submit" variant="primary" :disabled="this.loadingButtonUsername">
                    <b-spinner v-if="this.loadingButtonUsername" small></b-spinner>
                    <span v-else> <i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</span>
                  </b-button>
              </div>
            </b-form>
            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="56">
                <rect x="0" y="4" rx="0" ry="0" width="2" height="7" />
                <rect x="4" y="6" rx="1" ry="1" width="30" height="3" />
                <rect x="35" y="7" rx="1" ry="1" width="364" height="1" />

                <rect x="0" y="17" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="21" rx="1" ry="1" width="400" height="10" />

                <rect x="0" y="39" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="43" rx="1" ry="1" width="20" height="10" />
              </vue-content-loading>
            </div>

            <b-form v-if="!loadingContent" @submit.prevent="formChangePassword" class="con-radius-input">
              <div class="title-separator"><h4>تغيير كلمة المرور</h4></div>

              <div class="row">
                <b-form-group class="col-md-12 mb-3" label="كلمة المرور الحالية :" label-for="old_pass">
                    <b-form-input v-model="admin.password" :class="{ 'is-invalid': submitPassword && $v.admin.password.$error }" id="old_pass" type="text" placeholder="ادخل كلمة المرور الحالية"></b-form-input>
                    <div v-if="submitPassword && $v.admin.password.$error" class="invalid-feedback">
                      <span v-if="!$v.admin.password.required"> هذا الحقل الزامي </span>
                      <span v-if="!$v.admin.password.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 8 احرف على الاقل . </span>
                      <span v-if="!$v.admin.password.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 50 حرف على الاكثر . </span>
                    </div>
                </b-form-group>
                <b-form-group class="col-md-6 mb-3" label=" كلمة المرور الجديدة :" label-for="new_pass">
                    <b-form-input v-model="admin.newPassword" :class="{ 'is-invalid': submitPassword && $v.admin.newPassword.$error }" id="new_pass" type="text" placeholder="ادخل كلمة المرور الجديدة"></b-form-input>
                    <div v-if="submitPassword && $v.admin.newPassword.$error" class="invalid-feedback">
                      <span v-if="!$v.admin.newPassword.required"> هذا الحقل الزامي </span>
                      <span v-if="!$v.admin.newPassword.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 8 احرف على الاقل . </span>
                      <span v-if="!$v.admin.newPassword.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 50 حرف على الاكثر . </span>
                    </div>
                </b-form-group>
                <b-form-group class="col-md-6 mb-3" label="تأكيد كلمة المرور الجديدة :" label-for="confirm_pass">
                    <b-form-input v-model="admin.confirmNewPassword" :class="{ 'is-invalid': submitPassword && $v.admin.confirmNewPassword.$error }" id="confirm_pass" type="text" placeholder="ادخل كلمة المرور الجديدة"></b-form-input>
                    <div v-if="submitPassword && $v.admin.confirmNewPassword.$error" class="invalid-feedback">
                      <span v-if="!$v.admin.confirmNewPassword.required"> هذا الحقل الزامي </span>
                      <span v-if="!$v.admin.confirmNewPassword.sameAsPassword"> كلمة المرور غير متطابقة </span>
                    </div>
                </b-form-group>
              </div>
              <div>
                <hr>
                <b-button type="submit" variant="primary" :disabled="loadingButtonPassword"> 
                  <b-spinner v-if="loadingButtonPassword" small></b-spinner>
                  <span v-else> <i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</span>
                </b-button>
              </div>
            </b-form>
            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="80">
                <rect x="0" y="6" rx="0" ry="0" width="2" height="7" />
                <rect x="4" y="8" rx="1" ry="1" width="30" height="3" />
                <rect x="35" y="9" rx="1" ry="1" width="364" height="1" />

                <rect x="0" y="19" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="23" rx="1" ry="1" width="400" height="10" />

                <rect x="0" y="38" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="42" rx="1" ry="1" width="197" height="10" />
                <rect x="203" y="38" rx="1" ry="1" width="50" height="2" />
                <rect x="203" y="42" rx="1" ry="1" width="197" height="10" />

                <rect x="0" y="60" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="64" rx="1" ry="1" width="20" height="10" />
              </vue-content-loading>
            </div>

          </div>
        </div>
      </div>

    </div>
    
  </Layout>
</template>